<template>
  <div>
    <v-row>
      <v-col cols="12" sm="4">
        <span class="caption font-weight-bold">Forma de pagamento</span>
        <div>
          <px-forma-pagamento :forma-pagamento="venda.formaPagamento"
                              :prazo-pagamento="venda.prazoPagamento"/>
        </div>
      </v-col>
      <v-col cols="12" sm="4">
        <span class="caption font-weight-bold">Frete</span>
        <div>
          {{ venda.frete.tipoFrete }}
        </div>
      </v-col>
      <v-col cols="12" sm="4">
        <span class="caption font-weight-bold">Prazo de embarque</span>
        <div>
          {{ venda.frete.prazoEntrega }} dia(s)
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    venda: Object,
  },
};
</script>
